import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
import WorkIcon from "@material-ui/icons/Work";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import "./style.css";

const useStyles = makeStyles({
  avatar: {
    width: 150,
    height: 150,
  },

  name: {
    color: "#fff",
  },

  context: {
    color: "#d1d1dc",
  },

  social: {
    color: "#fff",
  },

  button: {
    borderRadius: 50,
    textTransform: "none",
    fontSize: "16px",
    fontWeight: 700,
  },
});

export default function Profile() {
  const classes = useStyles();

  return (
    <section id="profile" className="profile">
      {/* Background decorations */}
      <div className="gradient-circle circle-one"></div>
      <div className="gradient-circle circle-two"></div>

      <div className="hero-content">
        {/* Avatar */}
        <div className="avatar-wrapper">
          <div className="avatar-glow"></div>

          <Avatar
            className={classes.avatar}
            alt="Laraib"
            src="https://jthemes.net/themes/html/bolby/demo/images/avatar-1.svg"
          />
        </div>

        {/* Name */}
        <h1 className={classes.name}>
          Hi, I'm <span>Laraib</span>
        </h1>

        {/* Intro */}
        <p className={classes.context}>
          I am a <strong>Full-Stack Developer</strong> specializing in modern
          web applications and AI-powered solutions.
        </p>

        <p className="hero-description">
          I build modern, scalable web applications and intelligent experiences
          using React, Node.js, TypeScript, AI, and Retrieval-Augmented
          Generation (RAG).
        </p>

        {/* Social links */}
        <div className="social-container">
          <a
            href="https://www.linkedin.com/in/laraib24/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="social-link"
          >
            <LinkedInIcon className={classes.social} />
          </a>

          <a
            href="https://www.fiverr.com/sellers/lara244/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Fiverr"
            className="social-link"
          >
            <WorkIcon className={classes.social} />
          </a>

          <a
            href="https://github.com/Laraib24"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="social-link"
          >
            <GitHubIcon className={classes.social} />
          </a>
        </div>

        {/* CTA */}
        <Button
          className={classes.button}
          variant="contained"
          color="secondary"
          href="mailto:laraib24@outlook.com"
        >
          Hire Me
        </Button>

        {/* Scroll indicator */}
        <a href="#about" className="scroll-down">
          <span>Scroll Down</span>
          <KeyboardArrowDownIcon />
        </a>
      </div>
    </section>
  );
}
